import Vue from 'vue';
import '../styles/iview-variables.less';
import '../styles/global.less';
import ViewUI from 'view-design'

import locale from 'view-design/dist/locale/en-US';

Vue.use(ViewUI, { locale });
